function isValueWithinDomain(value, domain) {
  return value >= Math.min(...domain) && value <= Math.max(...domain);
}

export { isValueWithinDomain };
